import { TimelineLite, Power0, Back} from 'gsap';

const animation = (audioFn) => {
    const tl = new TimelineLite();

    tl.eventCallback('onStart', audioFn)
        .set(['.replay-section'], {pointerEvents: 'none'})
        .from('.beneficiary__heading', .8, {alpha: 0, ease: Power0.easeNone, delay: .3 })
        .staggerFrom('.beneficiary__content p', .8, {alpha: 0, ease: Power0.easeNone, delay: .3}, 0.7)
        .from('#gray-paper', .8, {alpha: .5, scaleY: 0, transformOrigin:"50% 100%"}, '+=0.8')
        .from('#blue-pencil', .8, {alpha: 0, ease: Power0.easeNone}, '+=0.3')
        .from('#blue-pencil', .8, {x: -100, rotation: -20, scale: 0.8, transformOrigin:"50% 50%"}, '-=.2')
        .staggerFrom('.gray-text', .8, {scaleX: 0, alpha: .5}, '-=.5', '-=.8')
        .from ('#heart-blue-half', .8, {y: '+=110%', alpha: .1, delay: 0.3})
        .from ('#heart-green-half', .8, {y: '+=110%', alpha: .1}, '+=.2')
        .from('#blue-paper', .8, {alpha: 0, y: '+=105%'}, '+=.7')
        .staggerFrom('.text-2', .8, {y: '+=130', alpha: 0.3, ease: Back.easeOut.config(.5)}, 0.3)
        .from('#envelope', .8, {x: '+=150'}, '+=0.5')
        .set('.replay-section', {pointerEvents: 'auto'}, '+=.3')
        .from('.replay-section', .8, {alpha: 0, delay: 0.3, ease: Power0.easeNone})
} 

export default animation